import { render, staticRenderFns } from "./noLocale.vue?vue&type=template&id=3fa54b3b&"
import script from "./noLocale.vue?vue&type=script&lang=js&"
export * from "./noLocale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports